<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    title="Уведомления"
    right
  >
    <template #button-content>
      <feather-icon
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
        :badge="newNotificationsCount"
      ></feather-icon>
    </template>

    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex align-items-center">
        <feather-icon
          class="text-primary mr-1"
          icon="BellIcon"
          size="21"
        ></feather-icon>
        <h5 class="notification-title mb-0 mr-auto">Уведомления</h5>
        <b-badge
          v-if="newNotificationsCount"
          pill
          variant="light-primary"
        >{{ newNotificationsCount }} &#128276;</b-badge>
      </div>
    </li>
    <vue-perfect-scrollbar
      v-if="notificationsCount"
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <b-link
        v-for="notification in notifications"
        :key="notification.id"
      >
        <b-media
          class="dropdown-notification__media"
          :class="{'dropdown-notification__media-not-viewed': !notification.viewed}"
          @mouseenter="onNotifMouseEnter(notification)"
        >
          <template #aside>
            <b-avatar
              size="32"
              :variant="'warning'"
            >
              <feather-icon :icon="'AlertCircleIcon'"></feather-icon>
            </b-avatar>
          </template>
          <div class="dropdown-notification__media-content">
            <div class="dropdown-notification__media-content-description">
              <p class="media-heading">
                <span class="font-weight-bolder">{{ notification.title }}</span>
                <span
                  v-if="notification.emoji"
                  class="ml-50"
                >{{ notification.emoji }}</span>
              </p>
              <small class="text-secondary">{{ notification.text }}</small>
            </div>
            <div class="dropdown-notification__media-content-time">
              <b-badge
                pill
                variant="light-primary"
              >
                {{ notification.created_at_str }}
              </b-badge>
            </div>
          </div>
        </b-media>
      </b-link>
    </vue-perfect-scrollbar>
    <div
      v-else
      class="dropdown-notification__empty"
    >
      <span class="dropdown-notification__empty-text">У вас пока нет уведомлений!</span>
      <span class="dropdown-notification__empty-smile">&#128578;</span>
    </div>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from 'moment/moment'
import { computed, onBeforeMount } from 'vue'
import store from '@/store'
import {
  loadOnlineSystemNotifications,
  viewMinimumSmsNotificationBalanceNotification,
  viewSubscriptionExpiredNotification,
} from '@/composables/notificationHelper'
import { formatDateAsTodayYesterdayOrOther } from '@/composables/dateTimeHelper'

export default {
  components: {
    BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, VuePerfectScrollbar
  },
  setup() {
    const systemNotifications = [
      {
        title: 'Server down',
        subtitle: 'USA Server is down due to hight CPU usage',
        type: 'light-danger',
        icon: 'XIcon'
      },
      {
        title: 'Sales report generated',
        subtitle: 'Last month sales report generated',
        type: 'light-success',
        icon: 'CheckIcon'
      },
      {
        title: 'High memory usage',
        subtitle: 'BLR Server using high memory',
        type: 'light-warning',
        icon: 'AlertTriangleIcon'
      },
    ]
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false
    }
    const notifications = computed(
      () => store.getters['notification/onlineSystemNotifications'].map(i => {
        i.created_at_str = i.created_at ? formatDateAsTodayYesterdayOrOther(i.created_at) : null
        i.emoji = getEmoji(i.type)
        return i
      })
    )
    const notificationsCount = computed(() => notifications.value.length)
    const newNotificationsCount = computed(() => notifications.value.filter(n => !n.viewed).length)

    const getEmoji = type => {
      let emoji = null
      switch (type) {
        case 'subscription-expired-notification':
        case 'minimum-sms-notification-balance':
          emoji = '\u2757'
          break
      }
      return emoji
    }

    const loadNotifications = async () => await loadOnlineSystemNotifications()
    const onNotifMouseEnter = async notif => {
      if (!notif.viewed) {
        switch (notif.type) {
          case 'subscription-expired-notification':
            await viewSubscriptionExpiredNotification()
            break
          case 'minimum-sms-notification-balance':
            await viewMinimumSmsNotificationBalanceNotification()
            break
        }
      }
    }

    onBeforeMount(async () => await loadNotifications())

    return {
      notifications,
      notificationsCount,
      newNotificationsCount,
      systemNotifications,
      perfectScrollbarSettings,

      onNotifMouseEnter
    }
  },
}
</script>

<style lang='scss'>

@import '@/assets/scss/variables/variables';

.dropdown-notification {

  &__media-not-viewed {
    background: lavender;
  }

  &__media-content {
    display: grid;
    grid-template-columns: auto auto;
    column-gap: 1rem;
  }

  &__media-content-time {
    display: flex;
    align-items: start;
    justify-content: end;

    span {
      color: $secondary-08;
      font-size: $font-size-11px;
    }
  }

  &__empty {
    padding: 1.5rem;
    text-align: center;
  }

  &__empty-text {
    width: 100%;
    font-weight: normal;
    font-size: 13px;
    margin-right: .5rem;
  }

  &__empty-smile {
    font-size: 17px;
  }
}

.dark-layout {
  .dropdown-notification {
    &__media-not-viewed {
      background: $theme-dark-body-bg;
    }

    &__empty-text {
      color: $theme-dark-label-color;
    }
  }
}

@media (min-width: 768px) {
  .dropdown-notification {
    .dropdown-menu {
      width: 500px !important;
    }
  }
}

</style>
